import Phaser from 'phaser';
import { TitleScene } from './scenes/TitleScene.js';
import { CoffeeShopScene } from './scenes/CoffeeShopScene.js';
import { DialogueManager } from './dialogue/DialogueManager.js';

// Initialize dialogue manager (will be shared across scenes)
window.dialogueManager = new DialogueManager();

const config = {
  type: Phaser.AUTO,
  width: 800,
  height: 600,
  parent: 'game-container',
  pixelArt: true,
  backgroundColor: '#1a1a2e',
  physics: {
    default: 'arcade',
    arcade: {
      gravity: { y: 0 },
      debug: false
    }
  },
  scene: [TitleScene, CoffeeShopScene]
};

const game = new Phaser.Game(config);
